import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';
import {browserHistory} from 'react-router';
import * as Request from '../tgccRequest';
import { CampusCloseX } from '../Components/CampusCloseX';
import {CampusFeedback} from './CampusFeedback';


const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    height: 'auto',
}

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column'
}

const woStyle: React.CSSProperties = {
    fontSize: '22px',
    letterSpacing: '3px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)',
    paddingTop:'10px',
    fontFamily:'BarlowMedium'
}

const statusStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 100,
    textTransform: 'uppercase',
    marginBottom: '10px',
    fontFamily:'BarlowMedium',
    color: 'rgba(88,88,88,0.7)',
    '@media(max-width:414px)': {
        fontSize:'16px'
    },
    '@media(max-width:375px)': {
        fontSize:'15px'
    },
    '@media(max-width:320px)': {
        fontSize:'12px'
    }
    
}
const imgStyle: React.CSSProperties = {
    alignSelf: 'center',
    width: 'auto',
    height: '600px',
    maxWidth: '80%',
    maxHeight: '750px',
    margin: '25px auto',
    boxShadow: Tgcc.Styles.boxShadow,
}

const btnStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '18px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    backgroundColor: '#3A54B4',
    padding: '5px 40px',
    cursor: 'pointer',
    maxWidth: '65%', 
    margin: '5px 20px',
}
const btnContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop:'20px'
}
const btnText: React.CSSProperties = {
    margin: '5px 10px',
    textTransform: 'uppercase',
    color: 'white',
    fontFamily: 'Lulo ',
    fontSize: '12px',
    letterSpacing: '3px',
    padding: '0',
    textAlign: 'center',
    '@media (max-width:414px)': { fontSize:'10px' }
}
const reviewTxt: React.CSSProperties = {
    textAlign:'center',
    color:'green',
    fontSize:'22px'
}

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#686868'
}
const createAcc: React.CSSProperties ={
    textAlign:'center',
}

const statStyle: React.CSSProperties = {
    color:'#E27558',
    fontFamily:'BarlowMedium'
}

const containerStyle: React.CSSProperties = {
    backgroundColor:'#E9E6E6',
    width:'775px',
    margin:'auto',
    textAlign:'center',
    borderRadius:'20px'
}
const imgContainer: React.CSSProperties = {
    width:'700px',
    backgroundColor:'white',
    margin:'auto'
}

const notLoggedIn: React.CSSProperties = {
    textAlign:'center',
    fontSize:'20px',
    fontFamily:'BarlowLight',
    position:'absolute',
    top:'70px',
    left:'50%',
    width: '500px',
    height:'50px',
    marginLeft:'-250px',
    zIndex:2,
    lineHeight:'48px',
    backgroundColor:'#E9E6E6',
    borderBottomLeftRadius:'15px',
    borderBottomRightRadius:'15px'
}
const approveDiv:React.CSSProperties = {
    display:'flex'
}
const disableBtn: React.CSSProperties = {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '18px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    backgroundColor: '#B5B5B4',
    padding: '5px 40px',
    maxWidth: '65%', 
    margin: '5px 20px',
    cursor:'not-allowed'
}
const grnBtn: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '18px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    backgroundColor: 'rgba(118,156,124,1)',
    padding: '5px 40px',
    cursor: 'pointer',
    maxWidth: '65%', 
    margin: '5px 20px',
}
const approveHdr: React.CSSProperties = {
    color:'#D47C61',
    textTransform:'uppercase',
    fontFamily:'Lulo',
    width:'75%',
    margin:'auto',
    fontSize:'20px'
}
const divText: React.CSSProperties = {
    color:'#88817D',
    width:'75%',
    margin:'auto',
    fontFamily:'BarlowLight'
}
var divText1 = Object.assign({},divText,{margin:'25px auto auto'});
const blackTxt: React.CSSProperties = {
    color:'black'
}
const textHdr: React.CSSProperties = {
    fontFamily:'Lulo',
    color:'#59514D',
    marginTop:'35px',
    marginBottom:'5px'
}
const contact: React.CSSProperties = {
    fontFamily:'BarlowLight',
    width:'75%',
    fontSize:'17px',
    margin:'25px auto',
    color:'#4A3E37'
}
const add: React.CSSProperties = {
    color:'#D17B63',
    fontFamily:'BarlowLight'
}
const checkbox: React.CSSProperties = {
    color:'#D17B63'
}

const rushFee: React.CSSProperties = {
    color:'red',
    fontFamily:'Lulo',
    fontSize:'16px',
    textAlign:'center',
    marginTop:'10px'
}

const dateInputStyle: React.CSSProperties = {
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '35px',
    border:'2px solid #E9E6E6',
    fontFamily:'BarlowLight',
    fontSize:'16px'
}

const dateRowStyle: React.CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const dateLabelStyle: React.CSSProperties = {
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'flex-start',
    fontWeight: 100,
    margin: 0,
    color: Tgcc.Styles.darkTextColor,
    lineHeight: '35px',
    fontFamily: 'Lulo',
}
class _CampusProofView extends React.Component<Tgcc.BaseProps, any>{
    state = { 
        proof: null,
        error: null,
        confirmProof:false,
        agree:false,
        isSubmitting: false,
    };


    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            var doRead = () => {Request.getProof(login, proofId, this.proofLoaded, this.loadError) };
            if(Object.keys(this.props.location.query).indexOf("Approve") > -1){
            } else if(Object.keys(this.props.location.query).indexOf("Cancel") > -1){
                Request.cancelProof(login, proofId, doRead, doRead);
            } else {
                doRead();
            }
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser(this.props.dispatch);
    }

    componentDidMount(){
        var el = document.getElementById('proofReview');
        el.scrollIntoView(false);
    }

    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }

    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof});
    }

    loadError = (err: any) => {
        console.log("error loading proof: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    canReviseProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'EMAILED':
                case 'MISSING':
                case 'M-PROOF':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    canApproveProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'EMAILED':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    reviseProof = () => {
        browserHistory.replace(Tgcc.Routes.CampusProofRevise(this.state.proof.proofId));
    }

    navigateToDashboard = () => {
        browserHistory.push(Tgcc.Routes.CampusDashboard);
    }
    approvalComplete = () => {
        try {
            this.setState({ isSubmitting: false });
            this.props.dispatch({
                type: Tgcc.StateAction.DialogAction,
                payload: {
                    action: Tgcc.DialogAction.ApprovalConfirmation,
                    payload: {
                        onContinue: this.navigateToDashboard
                    }
                }
            });
        } catch (error) {
            console.error("Error in approvalComplete:", error);
            this.setState({ isSubmitting: false });
            // Fallback: navigate to dashboard if dialog fails
            this.navigateToDashboard();
        }
    }
    approvalFailed = (err: any) => {
        this.setState({error: err, isSubmitting: false});
    }

    approveDesign = () => {
        // Prevent multiple submissions
        if (this.state.isSubmitting) {
            return;
        }
        
        try {
            // Validate required data exists
            if (!this.props.state.LoginData) {
                this.approvalFailed("You must be logged in to approve a proof.");
                return;
            }
            
            if (!this.state.proof || !this.state.proof.proofId) {
                this.approvalFailed("Proof information is missing. Please refresh the page and try again.");
                return;
            }
            
            if (!this.props.state.UserInfo) {
                this.approvalFailed("User information is missing. Please refresh the page and try again.");
                return;
            }
            
            // Set submitting state
            this.setState({ isSubmitting: true, error: null });
            
            // Create minimal payment config for simplified approval
            let paymentConfig = new Tgcc.PaymentConfig();
            paymentConfig.type = Tgcc.PaymentTypes.Classic; // Use Classic as default
            paymentConfig.quantity = "1"; // Minimal quantity
            paymentConfig.IsSpecialCase = true; // Mark as special case for simplified flow
            
            // Set default values for required fields to prevent API errors
            paymentConfig.trFirstName = paymentConfig.trFirstName || "";
            paymentConfig.trLastName = paymentConfig.trLastName || "";
            paymentConfig.trEmail = paymentConfig.trEmail || "";
            paymentConfig.address = paymentConfig.address || "";
            paymentConfig.city = paymentConfig.city || "";
            paymentConfig.State = paymentConfig.State || "";
            // zipcode is optional and should be a number, so we don't set a default
            paymentConfig.classicPaymentType = paymentConfig.classicPaymentType || "";
            
            // Direct approval without payment options page
            Request.approveProof(this.props.state.LoginData, this.state.proof, paymentConfig, this.props.state.UserInfo, this.approvalComplete, this.approvalFailed);
        } catch (error) {
            console.error("Error in approveDesign:", error);
            this.setState({ isSubmitting: false });
            this.approvalFailed("An unexpected error occurred. Please try again or contact support.");
        }
    }
    viewRoster = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.CampusProofRoster(this.props.location.query.proofId));
    }
    doTracking = (evt: React.MouseEvent<HTMLDivElement>, tracking: string) =>{
        evt.stopPropagation();
        window.open("https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=" + tracking, "tgcctracking");
    }
    close = () => {
        this.props.dispatch({type:Tgcc.StateAction.DialogAction, payload:null})
    }
    back = () => {
        this.setState({confirmProof:false});
        this.setState({agree:false});
        document.getElementById("approveBtn").style["display"] = "block";
        var el = document.getElementById('proofReview');
        el.scrollIntoView(false);

    }
    confirmApproval =() => {
        this.setState({confirmProof:true});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.ConfirmApproval, payload: {Message1: "To approve your order, please read our terms and agreements."}}});
    }
    readChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        console.log(evt.currentTarget.checked)
        if (evt.currentTarget.checked){
            this.setState({agree:true});
        }
        else {
            this.setState({agree:false})
        }
    }

    formatDate = (date:Date,days:number) => {
        var d = new Date(date.getTime());
        d.setDate(d.getDate() + days);
        var year = d.getFullYear();
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        var day = ("0" + d.getDate()).slice(-2);
        return year + '-' + month + '-' + day;
    }

    addBusinessDays = (date: Date, days: number) => {
        var d = new Date(date.getTime());
        var added = 0;
        while(added < days){
            d.setDate(d.getDate() + 1);
            var wd = d.getDay();
            if(wd != 0 && wd != 6) // skip Sun(0) and Sat(6)
                added++;
        }
        return d;
    }

    checkRushFee = () => {
        var today = this.formatDate(new Date(),5)
        console.log('Checking rush fee:', {
            inHandsDate: this.state.proof?.inHandsDate,
            today: today,
            proof: this.state.proof
        });
        if(this.state.proof){
            if(this.state.proof.inHandsDate &&  new Date(this.state.proof.inHandsDate)  <= new Date(today)   && this.state.proof.inHandsDate.length == 10 && new Date(this.state.proof.inHandsDate) >= new Date(this.formatDate(new Date(),0))){
                console.log('Rush fee should apply');
                return (
                    <div style={rushFee}>A rush fee may apply.</div>
                )
            }
        }
        console.log('No rush fee');
        return null;
    }

    inHandsDateChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        console.log('Date changed:', evt.currentTarget.value);
        var proof = this.state.proof;
        proof.inHandsDate = evt.currentTarget.value;
        this.setState({proof: proof});
        console.log('Updated proof:', proof);
    }
    confirmProof (){
        if(this.state.confirmProof){
            return (
                <div>
                    <h3 style={approveHdr}>To Approve your order, Please read and confirm our terms and agreements.</h3>
                    <h2 style={textHdr}>REVIEW DESIGN DETAILS</h2>
                    <div style={divText}>Please look over every detail of your proof – specifically <span style={blackTxt}>APPAREL STYLE, SPELLING, DATES, COLORS, SIZE</span> and <span style={blackTxt}>PLACEMENT</span>. Once you've approved your order, no further changes can be made.</div>
                    
                    <h2 style={textHdr}>CONFIRM IN-HANDS DATE</h2>
                    <div style={dateRowStyle}>
                        <label style={dateLabelStyle}>In-Hands Date:</label>
                        <input type='date' style={dateInputStyle} name='inHandsDate' onChange={this.inHandsDateChanged} value={this.state.proof?.inHandsDate || ""}/>
                    </div>
                    {this.checkRushFee()}
                    <div style={divText1}>Normal production time is 5-7 business days, unless a rush order.</div>
                    <div style={divText}>Your latest scheduled production date is {this.formatDate(this.addBusinessDays(new Date(),7),0)}.</div>
                    <h2 style={textHdr}>SHIPPING</h2>
                    <div style={divText}>Please verify the shipping address. We ship to the address you provide. Once an order has been picked up by FedEx, it's on its way!</div>
                    <div style={divText1}>If needed, expedited shipping is available</div>
                    <div style={add}>*additional rush fees may apply.</div>                   
                    <h2 style={contact}>Please contact your account manager if you have any questions at all!</h2>
                    <div>
                        <input type='checkbox' value="yes" onChange={this.readChanged}/>
                        <label htmlFor="checkbox" style={checkbox}>***I understand and agree to the information above.***</label>
                    </div>
                </div>

            )

        }
    }
    paymentBtn() {
        console.log(this.state.confirmProof);
        const isDisabled = this.state.isSubmitting;
        const buttonStyle = isDisabled ? disableBtn : grnBtn;
        
        if(this.state.agree){
            return(<div style={approveDiv}>
                    <div style={buttonStyle} onClick={isDisabled ? undefined : (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.approveDesign();
                    }} className='confirmDisable'>
                        <div style={btnText}>{this.state.isSubmitting ? "Submitting..." : "Approve Design"}</div>
                    </div>
                    <div style={btnStyle} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!isDisabled) {
                            this.back();
                        }
                    }}>
                            <div style={btnText}>BACK</div>
                    </div>
                </div>)
        }
        if(this.state.confirmProof && !this.state.agree) {
            return(<div style={approveDiv}>
                    <div style={disableBtn} className='confirmDisable'>
                        <div style={btnText}>Approve Design</div>
                    </div>
                    <div style={btnStyle} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.back();
                    }}>
                        <div style={btnText}>BACK</div>
                    </div>
                </div>)
        }
       
    }
    notLoggedin () {
        if(!this.props.state.LoginData){
            return (
                <div>
                    <div style={notLoggedIn} className='pVNotLoggedIn'>Please log in to view your proof.</div>
                </div>
            )}
    }
    getDashHeader(){
        return (
            <div style={createAcc} className='createAcct'>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>PROOF REVIEW</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }

    render(){
        var proof: Tgcc.Proof = this.state.proof || new Tgcc.Proof;
        var imgPath = proof.status != "REVIEW" ? Tgcc.getProofPath(proof.proofId) : Tgcc.Styles.missingProofImageSrc;
        var error = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div>:null;
        var canViewRoster = (proof && (proof.rosterCodes && proof.rosterCodes.length));

        var changeBtn = this.canReviseProof(proof) && !this.state.confirmProof ? <div className="hoverBorder" style={btnStyle} onClick={this.reviseProof}><div style={btnText}>make changes</div></div> : null;
        var approveBtn = this.canApproveProof(proof) && !this.state.confirmProof ? <div className="hoverBorder" style={btnStyle} onClick={this.confirmApproval}><div style={btnText}>Approve Design </div></div> : null;
        var viewRosterBtn = proof && canViewRoster ? <div className="hoverBorder" style={btnStyle} onClick={this.viewRoster}><div style={btnText}>view roster</div></div> : null;
        
        var text = proof.status == "REVIEW" ? <div style={reviewTxt}>Your artwork is being reviewed by our art staff.</div>: null;
        var trackStyle = Object.assign({}, statusStyle, {textDecoration: 'underline', cursor: 'pointer'});
        var tracking = proof && proof.tracking ? 
            <div style={trackStyle} onClick={ (evt) => this.doTracking(evt, proof.tracking)}>Tracking: {proof.tracking}</div> 
            : null;
        return (
                <div style={wrapperStyle}>
                {this.notLoggedin()}
                    <div style={contentStyle}>
                    <CampusHeader />
                    <CampusFeedback state={this.props.state} />
                        <div id="proofReview"></div>
                        {this.getDashHeader()}
                        <div style={containerStyle} className="proofViewBox">
                            <div style={woStyle}>{proof.proofId}</div>
                            <div style={statusStyle}>Order Status: <span style={statStyle}>{proof.status}</span></div>
                            {text}
                            {tracking}
                            <div style={imgContainer} className="proofViewCont">
                                <img style={imgStyle} src={imgPath} onError={this.onError} className="proofImg"/>
                                {error}
                                {this.confirmProof()}
                            </div>
                                <div style={btnContainerStyle}>
                                    {approveBtn}
                                    {changeBtn}
                                    {this.paymentBtn()}
                                    {viewRosterBtn}
                            </div>
                        </div>
                        <CampusFooter state={this.props.state} />
                    </div>
                 </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var CampusProofView = connect(mapStateToProps)(Radium(_CampusProofView));